import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { StyleSheet, css } from 'aphrodite';

import { Controller } from './common/Controller';
import { AppTheme } from './styles/AppTheme';

import { Header } from './components/Header';
import { NoPermission } from './common/components/NoPermission';

import { DashboardOrg } from './screens/admin/dashboard/DashboardOrg';

import { NotFound } from './screens/NotFound';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { UiHelper } from './common/helpers/UiHelper';
import { Home } from './screens/Home';
import { LoginPage } from './screens/LoginPage';

import { YoutubeLayout } from './screens/YoutubeLayout';
import { PdfLayout } from './screens/PdfLayout';
import { Mp4Layout } from './screens/Mp4Layout';
import { MultiLayout } from './screens/MultiLayout';

import { CampaignsAudioBO } from './screens/admin/CampaignsAudioBO';
import { PlaylistItems } from './screens/admin/PlaylistItems';
import { UsersOfOrgCustom } from './common/components/UsersOfOrgCustom';
import { Players } from './screens/Players';
import { SettingsMaster } from './screens/admin/SettingsMaster';
import { Jobs } from './screens/admin/Jobs';
import { VenuesWithSearch } from './screens/admin/VenuesWithSearch';
import { CampaignItems } from './screens/admin/CampaignItems';
import { CampaignsDisplay } from './screens/admin/CampaignsDisplay';
import { Venuegroups } from './screens/admin/Venuegroups';
import { VenuesIngroup } from './screens/admin/VenuesIngroup';
import { CustomOrgs } from './components/CustomOrgs';
import { CampaignsDisplayPartner } from './screens/admin/partners/CampaignsDisplayPartner';
import { CampaignItemsPartner } from './screens/admin/partners/CampaignItemsPartner';
import { VenuesOrgPartner } from './screens/admin/partners/VenuesOrgPartner';
import { CampaignsDisplayAdvertiser } from './screens/admin/advertisers/CampaignsDisplayAdvertiser';
import { CampaignItemsAdvertiser } from './screens/admin/advertisers/CampaignItemsAdvertiser';
import { VenuesOrgPa } from './screens/admin/pas/VenuesOrgPa';
import { VenuesOrgFa } from './screens/admin/fas/VenuesOrgFa';
import { VenuesOrgSite } from './screens/admin/sites/VenuesOrgSite';
import { AudioAdsSite } from './screens/admin/sites/AudioAdsSite';
import { DisplayAdsSite } from './screens/admin/sites/DisplayAdsSite';
import { AudioAdsPartner } from './screens/admin/partners/AudioAdsPartner';
import { DisplayAdsPartner } from './screens/admin/partners/DisplayAdsPartner';
import { Campaigns } from './screens/admin/advertisers/Campaigns';
import { CampaignPg } from './screens/admin/advertisers/CampaignPg';
import { CampaignPgm } from './screens/admin/advertisers/CampaignPgm';
import { Campaign } from './screens/admin/advertisers/Campaign';
import { UsersOfOrgCustomRead } from './components/UsersOfOrgCustomRead';
import { AdvertiserInfo } from './screens/admin/advertisers/AdvertiserInfo';
import { CampaignsSelfServe } from './screens/admin/CampaignsSelfServe';
import { VenuesSSCampaign } from './screens/admin/advertisers/VenuesSSCampaign';
import { RevenueOrgPa } from './screens/admin/pas/RevenueOrgPa';
import { RevenueOrgFa } from './screens/admin/fas/RevenueOrgFa';
import { RevenueOrgSite } from './screens/admin/sites/RevenueOrgSite';
import { MediaTagsListPartner } from './screens/admin/partners/MediaTagsListPartner';
import { TagsListPartner } from './screens/admin/partners/TagsListPartner';
import { AssetsListPartner } from './screens/admin/partners/AssetsListPartner';
import { DashboardPartner } from './screens/admin/partners/DashboardPartner';
import { AppConfig } from './AppConfig';
import { VenueExplorer } from './screens/admin/VenuesExplorer';
import { CampaignVenues } from './screens/admin/CampaignVenues';
import { CampaignVenuesPartner } from './screens/admin/CampaignVenuesPartner';
import { AdPopReport } from './screens/admin/AdPopReport';
import { PartnerDashboardCharts } from './screens/admin/partners/PartnerDashboardCharts';
import { AdPopReportPartner } from './screens/admin/partners/AdPopReportPartner';
import { CustomFieldsPartner } from './screens/admin/partners/CustomFieldsPartner';
import { CustomFieldsSuggestionPartner } from './screens/admin/partners/CustomFieldsSuggestionPartner';
import { AssetsItems } from './screens/admin/AssetsItems';
import { UsersOfOrgCustomPartner } from './common/components/UsersOfOrgCustomPartner';
import { Tasks } from './screens/admin/Tasks';
// import { Subtasks } from './screens/admin/Subtasks';
import { LayoutsItems } from './screens/admin/LayoutsItems';
import { EditLayoutWithMedia } from './components/EditLayoutWithMedia';
import { VenueTasksOrgPartner } from './screens/admin/partners/VenueTasksOrgPartner';
import { LayoutsOrgPartner } from './screens/admin/partners/LayoutsOrgPatner';
import { LayoutOrgPartner } from './screens/admin/partners/LayoutOrgPartner';
import { MobileFooter } from './components/MobileFooter';
import { VenueTasks } from './screens/admin/VenueTasks';
import { PlayersLocations } from './screens/PlayersLocations';
import { Task } from './screens/admin/Task';
import { Venue } from './screens/admin/Venue';
import { VenueOfSite } from './screens/admin/sites/VenueOfSite';
import { VenueOfPartner } from './screens/admin/partners/VenueOfPartner';
import { DevicesActivityPa } from './screens/admin/partners/DevicesActivityPa';
import { UsersOfOrg } from './common/components/UsersOfOrg';
import { DpsActivity } from './screens/admin/DpsActivity';
import { EventDetailsPartner } from './screens/admin/EventDetailsPartner';
import { EventsListPartner } from './screens/admin/EventsListPartner';
import { VenueFillRate } from './screens/admin/VenueFillRate';
import { VenueFillRatePartner } from './screens/admin/partners/VenueFillRatePartner';
import { Creatives } from './screens/admin/Creatives';
import { DeviceActivityPartner } from './screens/admin/partners/DeviceActivityPartner';
import { CampaignReport } from './screens/CampaignReport';

import { ExchangeReportsPartner } from './screens/admin/partners/ExchangeReportsPartner';
import { DdSearch } from './screens/admin/DdSearch';
import { ExchangeCreativesReviewQueue } from './screens/admin/ExchangeCreativesReviewQueue';
import { MediaTagsDisplay } from './screens/admin/MediaTagsDisplay';
import { BrandNamesDisplay } from './screens/admin/BrandNamesDisplay';
import { RestrictionTagsDisplay } from './screens/admin/RestrictionTagsDisplay';
import { TagsDisplay } from './screens/admin/TagsDisplay';

import { VenueHealthDashboard } from './screens/admin/VenueHealthDashboard';
import { VenueHealthTimeseries } from './screens/admin/VenueHealthTimeseries';
import { ScreenHealthSummary } from './screens/admin/ScreenHealthSummary';
import { ScreenHealthTimeseriesReport } from './screens/admin/ScreenHealthTimeseriesReport';
import { ScreenPerformanceDashboard } from './screens/admin/ScreenPerformanceDashboard';
import { DaypartingSchedule } from './screens/admin/DaypartingSchedule';
import { ScreenOttRenderrate } from './screens/admin/ScreenOttRenderrate';

const theme = createMuiTheme({
  props: {
    MuiModal: {
      disableScrollLock: true,
    },
  },
  palette: {
    primary: {
      main: AppTheme.primaryColor
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      'Red Hat Display',
      'sans-serif'
    ].join(',')
  }
});

const PublicRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if (props && props.path === '/login') {
      return <Redirect to={Controller.get().getHomeByRole()} />
    }
  }
  return <Route {...props} />
}

const ProtectedRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if(Controller.get().userMgr().isProductInstallerOnly()) {
      return <Redirect
        to={{
          pathname: '/no-permission',
          state: { redirectedfrom: props.path }
        }}
      />
    }
    if (props.userLoaded) {
      return <Route {...props} />
    }
    if (props.noPermission) {
      return <Redirect
        to={{
          pathname: '/no-permission',
          state: { redirectedfrom: props.path }
        }}
      />
    }
    Controller.get().loginMgr().bootstrap((err, data) => {
      if (err) {
        console.error('bootstrap err:', err)
        props.setNoPermission()
        return
      }

      if (props.path.startsWith('/admin/orgs/:orgId/users')) {
        if (!Controller.get().userMgr().isProductSU()) {
          props.setNoPermission()
          return
        }
      // } else if (props.path.startsWith('/admin/orgs')) {
      //   // Any path starts with /admin/orgs - users  has to have a role in that Org or a user of PRODUCT
      //   if (!Controller.get().userMgr().isProductSU() &&
      //     !Controller.get().userMgr().hasOrgRole(props.computedMatch.params.orgId, 'SUPERUSER')) {
      //     props.setNoPermission()
      //     return
      //   }
      } else if (props.path.startsWith('/admin/sites')) {
        if (!Controller.get().userMgr().isProductSU() &&
          !Controller.get().userMgr().isInOrg('PRODUCT') &&
          !Controller.get().userMgr().hasOrgRole(props.computedMatch.params.orgId, 'SUPERUSER')) {
          props.setNoPermission()
          return
        }
      } else if (props.path.startsWith('/admin/advertisers')) {
        if (!Controller.get().userMgr().isProductSU() &&
          !Controller.get().userMgr().isInOrg('PRODUCT') &&
          !Controller.get().userMgr().hasOrgRole(props.computedMatch.params.orgId, 'SUPERUSER')) {
          props.setNoPermission()
          return
        }
      } else if (props.path.startsWith('/admin/partners')) {
        if(props.path.startsWith('/admin/partners') && props.path.includes('devices-activity')) {
          if(!Controller.get().userMgr().isInOrg('PRODUCT') ) {
            props.setNoPermission()
            return
          }
        }
        if (!Controller.get().userMgr().isProductSU() && !Controller.get().userMgr().isInOrg('PRODUCT') && !Controller.get().userMgr().isInOrg(props.computedMatch.params.orgId)
        ) {
          props.setNoPermission()
          return
        }
      } else if (props.path.startsWith('/admin/pas')) {
        if (!Controller.get().userMgr().isProductSU() &&
          !Controller.get().userMgr().isInOrg('PRODUCT') &&
          !Controller.get().userMgr().hasOrgRole(props.computedMatch.params.orgId, 'SUPERUSER')) {
          props.setNoPermission()
          return
        }
      } else if (props.path.startsWith('/admin/fas')) {
        if (!Controller.get().userMgr().isProductSU() &&
          !Controller.get().userMgr().isInOrg('PRODUCT') &&
          !Controller.get().userMgr().hasOrgRole(props.computedMatch.params.orgId, 'SUPERUSER')) {
          props.setNoPermission()
          return
        }
      } else if (props.path.startsWith('/admin')) {
        // Any path starts with Admin - users has to have a role in PRODUCT Org
        if (!Controller.get().userMgr().isInOrg('PRODUCT')) {
          props.setNoPermission()
          return
        }
      }
      props.setUserLoaded && props.setUserLoaded()
    })
    return UiHelper.loadingView()
  } else {
    return <Redirect
      to={{
        pathname: '/login',
        state: { redirectedfrom: props.path }
      }}
    />
  }
}

class ScrollToTopBase extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (
      location.pathname !== prevProps.location.pathname ||
      location.search !== prevProps.location.search ||
      location.hash !== prevProps.location.hash
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

const ScrollToTop = withRouter(ScrollToTopBase);

class App extends Component {

  constructor(props) {
    //console.log('App::constructor')
    super(props);
    this.state = {
      currentUser: Controller.get().loginMgr().getCurrentUser()
    };
  }

  isPublic = () => {
    const pName = window.location.pathname
    if (pName.startsWith('/admin')) {
      return false
    }
    return true
  }

  render() {
    return (
      <Router>
        <ScrollToTop />
        <MuiThemeProvider theme={theme}>
          <Route path={'/'} component={({ location, history }) => {
            if (AppConfig.PRODUCTION_HOST && (window.location.hostname !== AppConfig.PRODUCTION_HOST)) {
              AppConfig.FEATURES_OFF = []
            }
            return (
              <div className={css(Styles.page)} style={this.isPublic() ? { backgroundColor: AppTheme.secondaryBg, flexDirection: 'column' } : { backgroundColor: AppTheme.primaryBg }}>
                {!this.isPublic() && <Header
                  className={css(Styles.header)}
                  currentUser={this.state.currentUser}
                  onDashboardClick={() => this.onDashboardClick()}
                  onLogoutClick={() => this.onLogoutClick()} />}
                {/* {this.isPublic() && <PublicHeader
                  className={css(Styles.header)}
                  currentUser={this.state.currentUser}
                  onDashboardClick={() => this.onDashboardClick()}
                  onLogoutClick={() => this.onLogoutClick()} />} */}
                <div className={css(Styles.content)}>
                  {this.renderRoute(history)}
                </div>
                {!this.isPublic() && Controller.get().loginMgr().getCurrentUser() &&
                  <MobileFooter/>
                }
                {/* {this.isPublic() && <PublicFooter />} */}
              </div>
            )
          }}
          />
        </MuiThemeProvider>
      </Router>
    );
  }

  setUserLoaded = () => {
    this.setState({ userLoaded: true });
  };

  setNoPermission = () => {
    this.setState({ noPermission: true });
  };

  getProtectedRoute(path, component) {
    return (
      <ProtectedRoute
        userLoaded={this.state.userLoaded}
        setUserLoaded={this.setUserLoaded}
        noPermission={this.state.noPermission}
        setNoPermission={this.setNoPermission}
        exact
        path={path}
        component={component}
      />
    );
  }

  renderRoute(history) {
    Controller.get().setNavigator(history);
    return (
      <Switch>
        {this.getProtectedRoute('/admin', CustomOrgs)}
        {this.getProtectedRoute('/admin/users', UsersOfOrg)}
        {this.getProtectedRoute('/admin/settings-master', SettingsMaster)}
        {this.getProtectedRoute('/admin/jobs', Jobs)}
        {/* {this.getProtectedRoute('/admin/screens', Venues)} */}
        {this.getProtectedRoute('/admin/screens', VenuesWithSearch)}
        {this.getProtectedRoute('/admin/audio-ads', CampaignsAudioBO)}
        {this.getProtectedRoute('/admin/audio-ads/:id/items', PlaylistItems)}
        {this.getProtectedRoute('/admin/campaigns', CampaignsDisplay)}
        {this.getProtectedRoute('/admin/campaigns/:id', CampaignItems)}
        {this.getProtectedRoute('/admin/campaigns/:id/screens', CampaignVenues)}
        {this.getProtectedRoute('/admin/venuegroups', Venuegroups)}
        {this.getProtectedRoute('/admin/venuegroups/:id/items', VenuesIngroup)}
        {this.getProtectedRoute('/admin/exchange-creatives', DdSearch)}
        {this.getProtectedRoute('/admin/exchange-creatives-review-queue', ExchangeCreativesReviewQueue)}
        {this.getProtectedRoute('/admin/dd-search', DdSearch)}

        {this.getProtectedRoute('/admin/reports', AdPopReport)}
        {this.getProtectedRoute('/admin/tasks', Tasks)}
        {this.getProtectedRoute('/admin/tasks/:id', Task)}
        {/* {this.getProtectedRoute('/admin/tasks/:id/subtasks', Subtasks)} */}
        {this.getProtectedRoute('/admin/dps-activity', DpsActivity)}
        {this.getProtectedRoute('/admin/screen-playback-history', VenueFillRate)}
        {/* {this.getProtectedRoute('/admin/screen-health/', VenueHealthDashboard)}
        {this.getProtectedRoute('/admin/screen-timeseries/', VenueHealthTimeseries)} */}
        {this.getProtectedRoute('/admin/screen-health-summary/', ScreenHealthSummary)}
        {this.getProtectedRoute('/admin/screen-health-timeseries-report/', ScreenHealthTimeseriesReport)}
        {this.getProtectedRoute('/admin/screen-fill-rate', ScreenPerformanceDashboard)}
        {this.getProtectedRoute('/admin/screen-ott-render-rate', ScreenOttRenderrate)}


        {this.getProtectedRoute('/admin/ss-campaigns', CampaignsSelfServe)}
        {this.getProtectedRoute('/admin/ss-campaigns/:id/items', CampaignItemsAdvertiser)}
        {this.getProtectedRoute('/admin/ss-campaigns/:id/screens', VenuesSSCampaign)}
        {this.getProtectedRoute('/admin/ss-campaigns/:id/advertiser', AdvertiserInfo)}
        {this.getProtectedRoute('/admin/assets', AssetsItems)}
        {this.getProtectedRoute('/admin/layouts', LayoutsItems)}
        {this.getProtectedRoute('/admin/layouts/:id', EditLayoutWithMedia)}
        {this.getProtectedRoute('/admin/screens/:id/tasks', VenueTasks)}
        {this.getProtectedRoute('/admin/screens/:id/dayparting-schedule', DaypartingSchedule)}
        {this.getProtectedRoute('/admin/screens/:id', Venue)}

        {this.getProtectedRoute('/admin/sites/:orgId', DashboardOrg)}
        {this.getProtectedRoute('/admin/sites/:orgId/users', UsersOfOrgCustom)}
        {this.getProtectedRoute('/admin/sites/:orgId/screens', VenuesOrgSite)}
        {/* {this.getProtectedRoute('/admin/sites/:orgId/screens/:id', VenueOfSite)} */}
        {this.getProtectedRoute('/admin/sites/:orgId/audio-ads', AudioAdsSite)}
        {this.getProtectedRoute('/admin/sites/:orgId/display-ads', DisplayAdsSite)}
        {this.getProtectedRoute('/admin/sites/:orgId/revenue', RevenueOrgSite)}

        {/* {this.getProtectedRoute('/admin/advertisers/:orgId', CampaignsDisplayAdvertiser)}
        {this.getProtectedRoute('/admin/advertisers/:orgId/campaigns', CampaignsDisplayAdvertiser)} */}
        {this.getProtectedRoute('/admin/advertisers/:orgId', Campaigns)}
        {this.getProtectedRoute('/admin/advertisers/:orgId/campaigns', Campaigns)}
        {this.getProtectedRoute('/admin/advertisers/:orgId/campaigns/:id/items', CampaignItemsAdvertiser)}
        {this.getProtectedRoute('/admin/advertisers/:orgId/campaigns/:id', Campaign)}
        {this.getProtectedRoute('/admin/advertisers/:orgId/campaigns/:id/pg', CampaignPg)}
        {this.getProtectedRoute('/admin/advertisers/:orgId/users', UsersOfOrgCustom)}

        {this.getProtectedRoute('/admin/partners/:orgId', PartnerDashboardCharts)}
        {this.getProtectedRoute('/admin/partners/:orgId/devices-activity', DevicesActivityPa)}
        {this.getProtectedRoute('/admin/partners/:orgId/exchange-reports', ExchangeReportsPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/devices-activity/screens/:id', DeviceActivityPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/screens', VenuesOrgPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/screen-playback-history', VenueFillRatePartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/campaigns', CampaignsDisplayPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/campaigns/:id', CampaignItemsPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/campaigns/:id/screens', CampaignVenuesPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/audio-ads', AudioAdsPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/display-ads', DisplayAdsPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/users', UsersOfOrgCustomPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/tags', TagsListPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/media-tags', MediaTagsListPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/assets', AssetsListPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/events', EventsListPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/events/:eventId', EventDetailsPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/reports', AdPopReportPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/custom-fields', CustomFieldsPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/custom-fields/:id/suggestions', CustomFieldsSuggestionPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/screens/:id/tasks', VenueTasksOrgPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/creatives', Creatives)}
        {/* {this.getProtectedRoute('/admin/partners/:orgId/screens/:id', VenueOfPartner)} */}
        {/* {this.getProtectedRoute('/admin/partners/:orgId/layouts', LayoutsOrgPartner)}
        {this.getProtectedRoute('/admin/partners/:orgId/layouts/:id', LayoutOrgPartner)} */}
        {this.getProtectedRoute('/admin/tags', TagsDisplay)}
        {this.getProtectedRoute('/admin/media-tags', MediaTagsDisplay)}
        {this.getProtectedRoute('/admin/brand-names', BrandNamesDisplay)}
        {this.getProtectedRoute('/admin/restriction-tags', RestrictionTagsDisplay)}

        {this.getProtectedRoute('/admin/pas/:orgId', VenuesOrgPa)}
        {this.getProtectedRoute('/admin/pas/:orgId/screens', VenuesOrgPa)}
        {this.getProtectedRoute('/admin/pas/:orgId/users', UsersOfOrgCustom)}
        {this.getProtectedRoute('/admin/pas/:orgId/revenue', RevenueOrgPa)}

        {this.getProtectedRoute('/admin/fas/:orgId', VenuesOrgFa)}
        {this.getProtectedRoute('/admin/fas/:orgId/screens', VenuesOrgFa)}
        {this.getProtectedRoute('/admin/fas/:orgId/users', UsersOfOrgCustom)}
        {this.getProtectedRoute('/admin/fas/:orgId/revenue', RevenueOrgFa)}

        {this.getProtectedRoute('/admin/venue-explorer', VenueExplorer)}

        <PublicRoute exact path={'/no-permission'} component={NoPermission} />
        <PublicRoute exact path={'/login'} component={LoginPage} />
        <PublicRoute exact path={'/terms'} component={Terms} />
        <PublicRoute exact path={'/privacy'} component={Privacy} />
        <PublicRoute exact path={'/lt/yt'} component={YoutubeLayout} />
        <PublicRoute exact path={'/lt/pdf'} component={PdfLayout} />
        <PublicRoute exact path={'/lt/mp4'} component={Mp4Layout} />
        <PublicRoute exact path={'/lt/multi'} component={MultiLayout} />
        <PublicRoute exact path={'/ads'} component={Players} />
        <PublicRoute exact path={'/locations'} component={PlayersLocations} />
        <PublicRoute exact path={'/campaign-pgm'} component={CampaignPgm} />
        <PublicRoute exact path={'/'} component={Home} />
        <PublicRoute exact path={'/crs/:id'} component={CampaignReport} />

        <PublicRoute component={NotFound} />
      </Switch>
    )
  }

  onLogoutClick() {
    //console.log('onLogoutClick');
    Controller.get().loginMgr().signOut();
    this.setState({
      currentUser: null
    })
  }

  onDashboardClick() {
    this.props.history.push('/admin');
  }
}

const Styles = StyleSheet.create({
  page: {
    display: 'flex',
    position: 'relative',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  header: {
    flex: '0 0 auto'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    // overflowX: 'hidden',
    flex: 1
  },
  footer: {
    flex: '0 0 auto'
  },
  drawerFiller: {
    width: AppTheme.drawerWidth,
    '@media (max-width: 767px)': {
      width: 'unset'
    }
  }
})

export default App;



// WEBPACK FOOTER //
// ./src/App.js